import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'

export class DeleteOfferApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'offer/delete/',
      requesterInfo,
    })
  }

  public async deleteOffer(id: number): Promise<any> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<any>()
  }
}
